const DELIVERY_ADDRESS_SEARCH_FORM_MODULE_DATA = {
  contentData: {
    searchStoreHeaderText: 'selectKFC',
    deliveryHeaderText: 'deliveryAddress',
    searchStoreModalContent: {
      formContent: {
        memberText: 'alreadyMember',
        singInLink: {
          linkUrl: null,
          linkText: 'signIn',
          targetType: '_blank',
        },
      },
    },
  },
};

export default DELIVERY_ADDRESS_SEARCH_FORM_MODULE_DATA;
